const CONSTANTS = Object.freeze({
  API_BASE_URL: process.env.VUE_APP_BASE_URL,
});

export default CONSTANTS;